import type * as React from 'react';
import { get } from '@Domain/Api';
import workflowCatalogFetched, {
	type DocumentTypePresetPayload,
	type WorkflowCatalogFetchedAction,
} from '@Application/Organizations/Workflows/Actions/workflowCatalogFetched';
import workflowCatalogFetchFailed, {
	type WorkflowCatalogFetchFailedAction,
} from '@Application/Organizations/Workflows/Actions/workflowCatalogFetchFailed';
import type FetchWorkflowCatalog from '@Application/Organizations/Workflows/Queries/FetchWorkflowCatalog';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = WorkflowCatalogFetchedAction | WorkflowCatalogFetchFailedAction;

export default (_query: FetchWorkflowCatalog) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<DocumentTypePresetPayload[]>(
				`${parameters.api.host}/api/workflow-catalog`,
			);

			const action = workflowCatalogFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowCatalogFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
